import { render, staticRenderFns } from "./MemoriesEditTags.vue?vue&type=template&id=3666b8ce"
import script from "./MemoriesEditTags.vue?vue&type=script&lang=js"
export * from "./MemoriesEditTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports